// CTV-637: the difference between "a campaign" and "a checkout that never
// finished".
//
// The wizard writes the submission + creative rows BEFORE the card is
// authorized (the Stripe intent is created inside the Pay handler, and
// `stripe.confirmPayment` runs afterwards). When that confirm fails, the rows
// are already committed and the submission is stranded in `pending_payment`.
//
// `pending_payment` is not a campaign: the buyer never paid, the publisher
// never saw it, and nothing was booked. But it is not hidden either — the buyer
// needs to see it to finish paying or discard it. So every buyer-facing surface
// must render it AS an unfinished checkout, not as a real campaign. That was the
// original bug: the creative Library badged an unpaid submission's commercial
// "In review" (its creative row really is `pending_review`) and linked to a
// detail page that showed a fake receipt, while My Campaigns hid it entirely.
//
// A discarded checkout lands on `canceled` (creative → `abandoned`), so it is
// NOT incomplete anymore — it's a normal terminal campaign the buyer chose to
// throw away. Only `pending_payment` is the "still needs a decision" state.
//
// IMPORTANT — this is a display-AND-policy predicate: it gates what the detail
// page, the Library badge, and the cancel/discard copy render. It must NEVER
// gate the by-id reads the payment state machine depends on (finalize, the
// idempotency resume, the previousSubmissionId cleanup, the Stripe webhook) —
// those legitimately read a live `pending_payment` row. See CTV-637.

/** True when the buyer's checkout never completed and still needs a decision. */
export function isIncompleteCheckout(submissionStatus: string | null | undefined): boolean {
  return submissionStatus === 'pending_payment';
}
